export enum AsyncStatus {
  NONE,
  LOADING,
  SUCCESS,
  FAIL,
}
